export enum InternalSources {
    PCS = 'pcs',
    RijekaTraffic = 'rt'
}

export type InternalSource = `${InternalSources}`;

export enum Sources {
    PCS = 'PCS',
    RijekaTraffic = 'RT',
    F4B = 'F4B',
    Cimis = 'CIM',
    AGCT = 'AGCT',
    RGW = 'RGW',
    UserCreated = 'USR'
}
